export enum AICoachGoalDecisionType {
  PayOffDebtUsingPlannery = 'PAY_OFF_DEBT_USING_PLANNERY',
  PayOffDebtUsingAvalanche = 'PAY_OFF_DEBT_USING_AVALANCHE',
  PayOffDebtUsingSnowball = 'PAY_OFF_DEBT_USING_SNOWBALL',
  ImproveCreditScore = 'IMPROVE_CREDIT_SCORE',
  BuildEmergencySavingsOneMonth = 'BUILD_EMERGENCY_SAVINGS_ONE_MONTH',
  BuildEmergencySavingsThreeMonths = 'BUILD_EMERGENCY_SAVINGS_THREE_MONTHS',
  BuildEmergencySavingsSixMonths = 'BUILD_EMERGENCY_SAVINGS_SIX_MONTHS',
  BuildEmergencySavings1K = 'BUILD_EMERGENCY_SAVINGS_1K',
  InvestForRetirement = 'INVEST_FOR_RETIREMENT',
  SaveForSpecificExpense = 'SAVE_FOR_SPECIFIC_EXPENSE',
}

export enum AICoachGoalType {
  PayDownCreditCardDebt = 'PAY_DOWN_CREDIT_CARD_DEBT',
  PayDownStudentLoanDebt = 'PAY_DOWN_STUDENT_LOAN_DEBT',
  BuildEmergencyFund = 'BUILD_EMERGENCY_FUND',
  SaveForSpecificExpense = 'SAVE_FOR_SPECIFIC_EXPENSE',
  ImproveCreditScore = 'IMPROVE_CREDIT_SCORE',
  SaveForRetirement = 'SAVE_FOR_RETIREMENT',
  Other = 'OTHER',
}

export enum AICoachGoalPriority {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}
